"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEnquiryCommentListItemDto = instanceOfEnquiryCommentListItemDto;
exports.EnquiryCommentListItemDtoFromJSON = EnquiryCommentListItemDtoFromJSON;
exports.EnquiryCommentListItemDtoFromJSONTyped = EnquiryCommentListItemDtoFromJSONTyped;
exports.EnquiryCommentListItemDtoToJSON = EnquiryCommentListItemDtoToJSON;
exports.EnquiryCommentListItemDtoToJSONTyped = EnquiryCommentListItemDtoToJSONTyped;
var EnquiryCommentFileDto_1 = require("./EnquiryCommentFileDto");
/**
 * Check if a given object implements the EnquiryCommentListItemDto interface.
 */
function instanceOfEnquiryCommentListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function EnquiryCommentListItemDtoFromJSON(json) {
    return EnquiryCommentListItemDtoFromJSONTyped(json, false);
}
function EnquiryCommentListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'],
        'message': json['message'] == null ? undefined : json['message'],
        'senderId': json['senderId'] == null ? undefined : json['senderId'],
        'senderRole': json['senderRole'] == null ? undefined : json['senderRole'],
        'senderName': json['senderName'] == null ? undefined : json['senderName'],
        'senderEmail': json['senderEmail'] == null ? undefined : json['senderEmail'],
        'createdAt': (new Date(json['createdAt'])),
        'isAutomated': json['isAutomated'] == null ? undefined : json['isAutomated'],
        'file': json['file'] == null ? undefined : (0, EnquiryCommentFileDto_1.EnquiryCommentFileDtoFromJSON)(json['file']),
    };
}
function EnquiryCommentListItemDtoToJSON(json) {
    return EnquiryCommentListItemDtoToJSONTyped(json, false);
}
function EnquiryCommentListItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'message': value['message'],
        'senderId': value['senderId'],
        'senderRole': value['senderRole'],
        'senderName': value['senderName'],
        'senderEmail': value['senderEmail'],
        'createdAt': value['createdAt'].toISOString(),
        'isAutomated': value['isAutomated'],
        'file': (0, EnquiryCommentFileDto_1.EnquiryCommentFileDtoToJSON)(value['file']),
    };
}
